import { useContext } from 'react';
import ModalContext from './ModalContext';
import { ModalContextProps } from './model/ModalContextProps';

export const useModal = (): ModalContextProps => useContext(ModalContext);
